<template>
  <div id="app">
    <header-bar />
    <router-view />
  </div>
</template>

<script>
import Header from './app/childs/Header';

export default {
  name: 'app',
  components: {
    'header-bar': Header,
  },
};
</script>

<style lang="scss">
@import "./Globals.scss";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0 auto;
  color: $sd-color-dark-blue;
  font-size: 13px;
  height: 100vh;
  width: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 14px;
}

a {
  outline: none;
  text-decoration: none;
  color: inherit;
}

.item-title {
  font-size: 15px;
  text-align: left;
  font-weight: bold;
  margin-left: 5%;
  margin-right: 5%;
  word-break: keep-all;
}

.vertical {
  vertical-align: middle;
}

.loading {
  opacity: 0.7;
};

.expander {
  cursor: pointer;
  height: 23px;
  width: 23px;
  background: $sd-color-blue;
}

.expander:hover {
  opacity: 0.8;
}

.title-style {
  display: inline-block;
  cursor: pointer;
}

.title-style:visited, .title-style {
  color: $sd-color-blue;
}

.title-style:hover {
  color: $sd-color-dark-blue;
  opacity: 0.8;
}

.fade-enter-active {
  transition: opacity .3s;
}
.fade-leave-active {
  transition: opacity .1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.sd-scrollable-div {
  overflow-y: scroll;
  height: 100vh;
}

.sd-status {
  border: 1px solid #ccc;
  border-radius: 3px;
}
.sd-green {
  background-color: #fff;
  border-color: #b2d8b9;
  color: #14892c;
}

.sd-yellow {
  background-color: #fff;
  border-color: #ffe28c;
  color: #594300;
}

.sd-blue-gray {
  background-color: #fff;
  border-color: #4a6785;
  color: #4a6785;
}

@media (max-width: 1100px) {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 13px;
  }
}

@media (max-width: 720px) {
  .item-title {
    margin-bottom: 10px;
    font-size: 13px;
  }
}

@media (max-width: 350px) {
  .item-title {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?15b29963